export type ApiEnvironment = 'development' | 'production' | 'test' | string;

export type ApiUrlOptions = {
  environment: ApiEnvironment;
  envUrl?: string;
  envHost?: string;
  envPort?: string;
  envPath?: string;
  browserHostname?: string;
};

const PLACEHOLDER_PATTERN = /IP_ESTATICO_SERVIDOR|SEU_HOST|SEU_IP|YOUR_HOST|YOUR_IP/i;
const LOCALHOST_URL_PATTERN = /\/\/(localhost|127\.0\.0\.1)(:|\/)/i;

function trim(value: unknown) {
  return String(value || '').trim();
}

export function resolveApiUrl(options: ApiUrlOptions) {
  const environment = trim(options.environment);
  const envUrl = trim(options.envUrl);
  const envHost = trim(options.envHost);
  const envPort = trim(options.envPort) || '3001';
  const envPathRaw = trim(options.envPath) || '/api';
  const browserHostname = trim(options.browserHostname) || 'localhost';
  const isProduction = environment === 'production';
  const isRemoteAccess = !['localhost', '127.0.0.1', '::1'].includes(browserHostname);
  const envUrlIsPlaceholder = Boolean(envUrl && PLACEHOLDER_PATTERN.test(envUrl));
  const envPointsToLocalhost = Boolean(envUrl && LOCALHOST_URL_PATTERN.test(envUrl));

  if (!/^\d{1,5}$/.test(envPort) || Number(envPort) < 1 || Number(envPort) > 65535) {
    throw new Error('REACT_APP_API_PORT invalido');
  }

  const envPath = `/${envPathRaw.replace(/^\/+|\/+$/g, '')}`;

  if (isProduction) {
    if (!envUrl) return '/api';
    if (envUrlIsPlaceholder) {
      throw new Error('REACT_APP_API_URL contem placeholder invalido');
    }

    if (envUrl.startsWith('/')) {
      if (envUrl.startsWith('//')) {
        throw new Error('REACT_APP_API_URL relativa nao pode ser protocol-relative');
      }
      return `/${envUrl.replace(/^\/+|\/+$/g, '')}`;
    }

    const parsed = new URL(envUrl);
    if (parsed.protocol !== 'https:') {
      throw new Error('REACT_APP_API_URL absoluta deve usar HTTPS em producao');
    }
    if (parsed.username || parsed.password) {
      throw new Error('REACT_APP_API_URL nao pode conter credenciais');
    }

    return envUrl.replace(/\/+$/, '');
  }

  const explicitApiUrl = !envUrlIsPlaceholder
    && (envUrl || (envHost ? `http://${envHost}:${envPort}${envPath}` : ''));

  if (explicitApiUrl && !(isRemoteAccess && envPointsToLocalhost)) {
    return explicitApiUrl.replace(/\/+$/, '');
  }

  return `http://${browserHostname}:${envPort}${envPath}`;
}

export function resolveApiTimeout(value: unknown) {
  const timeout = Number(value || 30000);
  if (!Number.isFinite(timeout) || timeout < 1000 || timeout > 120000) {
    throw new Error('REACT_APP_API_TIMEOUT_MS invalido');
  }
  return timeout;
}
